import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../../hooks/useLocalizedPath';
import styles from './BlogCard.module.css';

interface BlogCardProps {
  slug: string;
  title: string;
  description: string;
  date: string;
  author: string;
  category: string;
  readingTime: number;
  thumbnail: string;
}

export function BlogCard({
  slug,
  title,
  description,
  date,
  category,
  readingTime,
  thumbnail,
}: BlogCardProps) {
  const { t, i18n } = useTranslation('blog');
  const { lp } = useLocalizedPath();

  const formattedDate = new Date(date).toLocaleDateString(
    i18n.language === 'fr' ? 'fr-FR' : 'en-US',
    { year: 'numeric', month: 'long', day: 'numeric' }
  );

  const categoryLabel = t(`categories.${category}`);

  return (
    <article className={styles.card}>
      <Link to={lp(`/blog/${slug}`)} className={styles.thumbnailLink}>
        <div className={styles.thumbnailWrapper}>
          <img
            src={thumbnail}
            alt={title}
            className={styles.thumbnail}
            loading="lazy"
          />
          <span className={`${styles.badge} ${styles[`badge_${category}`] || ''}`}>
            {categoryLabel}
          </span>
        </div>
      </Link>
      <div className={styles.content}>
        <Link to={lp(`/blog/${slug}`)} className={styles.titleLink}>
          <h3 className={styles.title}>{title}</h3>
        </Link>
        <p className={styles.description}>{description}</p>
        <div className={styles.footer}>
          <span className={styles.meta}>
            {formattedDate} · {readingTime} {t('listing.minRead')}
          </span>
          <Link to={lp(`/blog/${slug}`)} className={styles.readMore}>
            {t('listing.readMore')} →
          </Link>
        </div>
      </div>
    </article>
  );
}
